<script setup lang="ts">
import Obra from '@/services/model/obra';
import ListagemObras from '@/components/ListagemObras.vue';
import NotificacaoComponent from "@/components/shared/notificacoes/NotificacaoComponent.vue";
import AtenaIcon from "@/components/icons/AtenaIcon.vue";
import IconNotificacaoVazio from "@/components/icons/IconNotificacaoVazio.vue";
import FavoritoSelecionado from '@/components/icons/FavIcon.vue'
import FavoritoVazio from '@/components/icons/Fav2Icon.vue'
import SidebarTituloComponent from '@/components/desktop/SidebarTituloComponent.vue';
import { useSidebarStore } from '@/stores/sidebar';
import { useObraStore } from '@/stores/obras';
useSidebarStore();
useObraStore();

</script>
<template>
    <div id="main-sidebar" class="sidebar overflow-hidden">
        <div class="row">
            <div class="d-flex bd-highlight altura-icone-menu-expansao">
                <div class="p-2 bd-highlight " :class="!menuRetratil ? 'sidebar-collapse-icon-flex' : ''"
                    id="main-sidebar-icone-atena">
                    <div class="sidebar-icon">
                        <atena-icon />
                    </div>
                </div>
                <div class="p-2 flex-grow-1 bd-highlight sidebar-search-flex" id="main-sidebar-menu-expandido">
                    <div class="input-group mt-1 sidebar-search-input-group">
                        <input type="text" class="form-control search-field" placeholder="" v-model="textoBusca"
                            v-on:keyup.enter="efetuarBusca" />
                        <button class="btn btn-outline-secondary search-button" type="button" id="buttonSearch"
                            @click="efetuarBusca">
                            <i class="bi bi-search"></i>
                        </button>
                        <button class="btn btn-outline-secondary search-button" type="button" id="buttonReload"
                            @click="limparBusca">
                            <i class="bi bi-arrow-clockwise"></i>
                        </button>
                    </div>
                </div>
                <div class="p-2 bd-highlight sidebar-collapse-button-flex" id="main-sidebar-botao-expansao-menu">
                    <div @click="toggleSidebar(!menuRetratil ? 'obras' : 'notificacoes')" class="fs-2">
                        <div class="sidebar-collapse-button">
                            <i class="bi bi-chevron-right chevron-navy"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sidebar-titulo-component :listagem-ativa="menuRetratil" />
        <div class="d-flex flex-column flex-shrink-0  sidebar-content float-start">
            <div class="bd-highlight flex-grow-1 ">
                <ul class="nav nav-pills nav-flush flex-column mb-3 text-center">
                    <!-- 
                        TODO: #17084
                        Desabilitado temporariamento Task #17084
                        http://redmine.eisolucoesinteligentes.com.br/redmine/issues/17084
                    -->
                    <!-- 
                        <li>
                            <a href="javascript:void(0);" class="nav-link py-3 rounded-0 "
                                @click="toggleSidebar('notificacoes')">
                                <icon-notificacao-vazio />
                            </a>
                        </li>
                        <div class="menu-border-bottom"></div> 
                    -->
                    <li>
                        <a class="nav-link py-3 rounded-0 circle orange" @click="toggleFiltroFavoritos()">
                            <FavoritoVazio v-if="!ObraStore.favoritos" />
                            <FavoritoSelecionado v-if="ObraStore.favoritos" />
                        </a>
                    </li>
                    <div class="menu-border-bottom"></div>
                </ul>
                <ul class="nav nav-pills nav-flush flex-column mb-auto text-center">
                    <li>
                        <a href="javascript:void(0);" class="nav-link py-1 rounded-0" @click="filtrarPorStatus('vermelho')">
                            <i :class="obterIconeSinaleiro('vermelho')"></i>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" class="nav-link py-1 rounded-0" @click="filtrarPorStatus('amarelo')">
                            <i :class="obterIconeSinaleiro('amarelo')"></i>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" class="nav-link py-1 rounded-0" @click="filtrarPorStatus('verde')">
                            <i :class="obterIconeSinaleiro('verde')"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="d-flex flex-column flex-shrink-0  sidebar-holder vh-100 overflow-auto" style="padding-bottom: 120px;">
            <listagem-obras v-if="SidebarStore.open && SidebarStore.menu === 'obras'" v-on:selecionar="selecionar" />
            <notificacao-component v-if="SidebarStore.open && SidebarStore.menu === 'notificacoes'" />
        </div>
    </div>
</template>
<script lang=ts>
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ListaDesktopView',
    data() {
        return {
            textoBusca: "",
            titulosSinaleiro: ['vermelho', 'amarelo', 'verde'],
        };
    },
    computed: {
        ...mapStores(useSidebarStore),
        ...mapStores(useObraStore),
    },
    watch: {
        "SidebarStore.open": function () {
            this.animateSidebar();

            if (!this.SidebarStore.open) {
                this.SidebarStore.menu === ''
                this.animateSidebar(true)
            }
        },
    },
    props: {
        menuRetratil: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        toggleSidebar(menu: string) {
            this.SidebarStore.toggle(menu)
        },
        animateSidebar(desativar: boolean = false) {
            const mainSidebar = document.getElementById("main-sidebar") as HTMLElement;
            const mainLayout = document.getElementById("main-layout") as HTMLElement;
            const sidebarCollapseButtonFlex = document.querySelector(".sidebar-collapse-button-flex") as HTMLElement;
            const sidebarSearchFlex = document.querySelector(".sidebar-search-flex") as HTMLElement;
            const sidebarCollapseIconFlex = document.querySelector(".sidebar-collapse-icon-flex") as HTMLElement;

            if (desativar) {
                mainSidebar.classList.remove("active-sidebar")
                mainLayout.classList.remove("active-sidebar")
                sidebarCollapseButtonFlex.classList.remove("active-sidebar")
                sidebarSearchFlex.classList.remove("active-sidebar")

                if (sidebarCollapseIconFlex) {
                    sidebarCollapseIconFlex.classList.remove("active-sidebar")
                }

                return
            }

            mainSidebar.classList.toggle("active-sidebar");
            mainLayout.classList.toggle("active-sidebar");
            sidebarCollapseButtonFlex.classList.toggle("active-sidebar");
            sidebarSearchFlex.classList.toggle("active-sidebar");

            if (sidebarCollapseIconFlex) {
                sidebarCollapseIconFlex.classList.toggle("active-sidebar")
            }
        },
        filtrarPorStatus(status: string) {
            this.ObraStore.filtrarPorStatus(status);
        },
        toggleFiltroFavoritos() {
            this.ObraStore.filtrarPorFavoritos(!this.ObraStore.favoritos);
        },
        obterIconeSinaleiro(status: string): string {
            if (this.ObraStore.statusBusca.includes(status)) {
                return 'bi bi-circle-fill circle circle-' + this.obterCorBootstrap(status);
            }

            return 'opacidade bi bi-circle circle circle-' + this.obterCorBootstrap(status);
        },
        obterCorBootstrap(status: string): string {
            switch (status) {
                case 'vermelho':
                    return 'red';
                case 'amarelo':
                    return 'yellow';
                case 'verde':
                    return 'green';
            }
            return 'yellow';
        },
        efetuarBusca() {
            this.ObraStore.filtrar(this.textoBusca);
        },
        selecionar(obra: Obra) {
            this.ObraStore.selecionar(obra);
        },
        limparBusca() {
            if (this.ObraStore.listarObrasSelecionadas) {
                this.ObraStore.limparSelecoes();
            }
            else {
                this.textoBusca = '';
                this.efetuarBusca();
            }

        }
    }
});
</script>
<style scoped>
.bi::before {
    font-weight: bolder !important;
    /* Aumenta a espessura dos ícones (valor pode variar dependendo do efeito desejado) */
}

.altura-icone-menu-expansao {
    height: 60px;
}

.atena-icon>svg {
    width: 35px;
    height: auto;
    margin-top: 30px;
    margin-left: 10px;
    z-index: 1000;
}

svg {
    cursor: pointer;
}

.opacidade{
    opacity: 0.5;
}

#main-sidebar.active-sidebar {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
}
</style>